import { handleError } from '@utils/handleError'

const REGISTRY_COMPONENT_URL = 'https://radianos.com/api/components'

export type RegistryComponentFile = {
  name: string
  dir: string
  content: string
}

export type RegistryComponent = {
  name: string
  dependencies?: string[]
  registryDependencies?: string[]
  files: RegistryComponentFile[]
  type: string
}

export type RegistryComponents = RegistryComponent[]

export const getRegistryComponents = async (): Promise<RegistryComponents> => {
  try {
    const response = await fetch(REGISTRY_COMPONENT_URL)

    if (!response.ok) {
      const errorMessage = `Failed to fetch data from ${REGISTRY_COMPONENT_URL}.\nStatus: ${response.status} - ${response.statusText}`
      throw new Error(errorMessage)
    }
    const data = await response.json()
    return data
  } catch (error) {
    handleError(error)
  }
}
